import { NavigateFunction, Route } from 'react-router-dom';
import ProtectedRoute from 'src/auth/ProtectedRoute';
import type { AuthStatus } from 'src/auth/useAuth';
import { ERIS_Screen } from './ErisScreen';
import { ErisScreensMap } from './ErisScreenMap';

type BuildEnv = 'er' | 'wa' | 'wf' | 'all' | undefined;
const env = process.env.REACT_APP_BUILD_NAME as BuildEnv;

export const ERIS_Root = env === 'er' ? '' : '/er';

export const buildErisPath = (path: string) => {
  if (!ERIS_Root) return path.startsWith('/') ? path : `/${path}`;

  if (path === ERIS_Root || path.startsWith(`${ERIS_Root}/`)) return path;

  return `${ERIS_Root}${path.startsWith('/') ? path : `/${path}`}`;
};

export const erisNavigate = (navigate: NavigateFunction, path: string) => {
  const fullPath = buildErisPath(path);
  navigate(fullPath, { replace: true });
};

export const registerErisScreens = (status: AuthStatus) => {
  const loginScreen = ERIS_Screen.Login;
  const loginRoute = ErisScreensMap[loginScreen];
  const otherScreens = Object.values(ERIS_Screen).filter(
    (screen) => screen !== loginScreen && screen !== ERIS_Screen.AuthCallback
  );
  return [
    <Route key={loginRoute.key} path={loginRoute.path} element={loginRoute.mobileComponent} />,
    <Route
      key={ERIS_Screen.AuthCallback}
      path={ErisScreensMap[ERIS_Screen.AuthCallback].path}
      element={ErisScreensMap[ERIS_Screen.AuthCallback].mobileComponent}
    />,
    ...otherScreens.map((screen) => {
      const route = ErisScreensMap[screen];
      return (
        <Route
          key={route.key}
          path={route.path}
          element={
            <ProtectedRoute status={status} redirectPath={buildErisPath(loginRoute.path)}>
              {route.mobileComponent}
            </ProtectedRoute>
          }
        />
      );
    }),
  ];
};
